import { render, staticRenderFns } from "./IconQbjb.vue?vue&type=template&id=081e4afc"
import script from "./IconQbjb.vue?vue&type=script&lang=js"
export * from "./IconQbjb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports